import type { ReactNode } from 'react'

export type DetailRow = { label: string; value: ReactNode; hint?: string | null }

/**
 * Figures as plain rows, label left and value right, divided by hairlines
 * (John, Nov 1 2026: never a grid of stat tiles). A row without a value is
 * left out; a hint sits muted after the value.
 */
export function DetailList({ rows }: { rows: DetailRow[] }) {
  const shown = rows.filter((row) => row.value !== null && row.value !== undefined && row.value !== '')
  if (shown.length === 0) return null
  return (
    <dl className="divide-y divide-line border-t border-line">
      {shown.map((row) => (
        <div key={row.label} className="flex items-baseline justify-between gap-4 py-2.5">
          <dt className="text-muted">{row.label}</dt>
          <dd className="flex min-w-0 items-baseline gap-1.5 text-right font-medium tabular-nums">
            {row.value}
            {row.hint ? <span className="font-normal text-muted">{row.hint}</span> : null}
          </dd>
        </div>
      ))}
    </dl>
  )
}
